module.exports = __webpack_public_path__ + "img/v1-radio.7036814a.png";